/**
 * @fileoverview Prompt template for plot-ideas-generator-v2.
 */

export const prompt = `
You are an expert narrative designer and a master plot architect.

## TASK INSTRUCTIONS:
Your mission is to review the provided story context and generate three unique, high-level plot concepts.
1.  **Analze:** Look at the blurb, story type, word count, genre, characters, and any other available context.
2.  **Ideate:** Create five to six distinct and genuinely different directions the story could go. They should vary in theme, tone, or the central conflict. Make sure they match the story type and word count - create simple ideas for a short story, complex ideas for a novel, and so on.
3.  **Choose and Summarize:** For the top three ideas, provide a compelling one-sentence title and a concise summary (max 100 words) of the plot concept. Do NOT generate a full plot outline.



<<<userMessage>>>

## PRIMARY TASK CONTEXT

<<<storyContext>>>

<<<loreContext>>>

<<<seriesContext>>>

## SECONDARY TASK CONTEXT

<<<characters>>>

<<<worldElements>>>

---

## OUTPUT INSTRUCTIONS:
Provide your output in the required JSON format.
`;
